import axios from 'axios'

export default class ReportService {
  static async downloadReport (report, params ) {
    await axios({
      method: 'GET',
      url: process.env.VUE_APP_INTERNAL_API_BASEURL + '/report/' + report,
      params: params !== undefined ? params : null,
      headers: { 'Accept': 'text/csv' },
      responseType: 'blob'
    }).then((response) => {
      this.download(response)
    })
  }

  static download(response) {
    const blob = new Blob([response.data], { type: response.data.type })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url

    const contentDisposition = response.headers['content-disposition']
    let fileName = 'report'
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
      if (fileNameMatch.length === 2) {
        fileName = fileNameMatch[1]
      }
    }
    link.setAttribute('download', fileName)

    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }
}
